import React from "react";

const PAGE_FLASH_OVERLAY_CSS = `
	@keyframes er-page-flash-enter-overlay {
		0% { opacity: 1; background: #fff; }
		18% { opacity: 1; }
		100% { opacity: 0; visibility: hidden; }
	}
	@keyframes er-page-flash-exit-overlay {
		0%, 35% { opacity: 0; background: #fff; }
		55% { opacity: 1; }
		100% { opacity: 1; }
	}
	@keyframes er-page-flash-both-overlay {
		0% { opacity: 1; background: #fff; }
		22% { opacity: 0; visibility: hidden; }
		100% { opacity: 0; visibility: hidden; }
	}
	.er-page-flash-overlay {
		position: absolute;
		inset: 0;
		z-index: 850;
		pointer-events: none;
		border-radius: inherit;
		background: #fff;
	}
`;

export default function EscapeRoomPageFlashOverlay({ mode = "enter", durationMs = 350, overlayKey }) {
	const sec = Math.max(0.12, (Number(durationMs) || 350) / 1000);
	const anim =
		mode === "exit"
			? "er-page-flash-exit-overlay"
			: mode === "both"
				? "er-page-flash-both-overlay"
				: "er-page-flash-enter-overlay";
	return (
		<>
			<style>{PAGE_FLASH_OVERLAY_CSS}</style>
			<div
				key={overlayKey || `flash-${mode}`}
				className="er-page-flash-overlay"
				style={{
					"--er-flash-dur": `${sec}s`,
					animation: `${anim} var(--er-flash-dur) ease-out forwards`,
				}}
				aria-hidden
			/>
		</>
	);
}
